import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideAuth } from './auth/provide-auth';
import { provideCarbonIcons } from './register-icons';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // Default `unmatchedInputBehavior: 'alwaysUndefined'` overwrites every
    // input on a routed component with `undefined` unless its name matches
    // a route/query param — including inputs with their own local fixture
    // defaults, like the dashboards' data inputs. 'undefinedIfStale' leaves
    // those alone and only binds inputs the router actually has data for.
    provideRouter(appRoutes, withComponentInputBinding({ unmatchedInputBehavior: 'undefinedIfStale' })),
    provideCarbonIcons(),
    provideAuth(),
  ]
};
